export const lockedFallbackDefaultTitle = 'Acesso bloqueado';
export const lockedFallbackDefaultMessage = 'Sua assinatura não dá acesso a essa página. Para ter acesso entre em contato.';
